export const CAMERA_SETUP_STEPS = [
	{
		id: 0,
		label: "Region of Interest"
	},
	{
		id: 1,
		label: "Define Direction Arrow"
	},
	{
		id: 2,
		label: "Crossing Lines"
	}
];

export const CANVAS_POLYGON_COORDINATE_RADIUS = 5;
export const CANVAS_STROKE_COLOR = "yellow";

export const DEFAULT_NUMBER_OF_LINES = 5;

// export const RTSP_REGEX = /^(\/dev\/video[0-9]{1,2}|rtsp:\/\/.*)$/g;
export const URL_REGEX =
	/https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/;

export const RTSP_REGEX =
	/^(rtsp):\/\/(?:([^\s@/]+?)[@])?([^\s/:]+)(?:[:]([0-9]+))?(?:(\/[^\s?#]+)([?][^\s#]+)?)?([#]\S*)?/;
